import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useLocation } from "react-router-dom";
import CheckoutForm from "./CheckoutPage";

type Props = {};

const Checkout = (props: Props) => {
  const location = useLocation();
  const [amount, setAmount] = useState(0); // Stato per l'importo

  const stripePromise = loadStripe(
    "pk_live_51PTqh2EPWM91kKnd29n1JKTHvfUQRdWGdF2NbPsJK2eJJFHK5hVD8LX6tUZ1JG8rlJbWVcCgatfHSx3BBlYf7vrP00iyxTXD6h"
  ); // Replace with your publishable key
  // import meta.env.VITE_STRIPE_PK is the publishable key you can either directly paste your stripe key here but not recommending if you are planning to upload the code on github as it should remain only available to you or save the key in .env file
  const options: {
    mode: "payment" | "setup" | "subscription";
    amount: number;
    currency: string;
  } = {
    mode: "payment", // Must be one of: "payment", "setup", or "subscription"
    amount: 1099,
    currency: "eur",
  };

  return (
    <div className="flex container mt-8">
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm onAmountChange={setAmount} />
      </Elements>
    </div>
  );
};

export default Checkout;
